<app-topnav></app-topnav>
<div *ngIf="isUserLoggedIn">
  <!-- <app-difftool></app-difftool> -->
  <router-outlet></router-outlet>
</div>
<div *ngIf="!isUserLoggedIn">
  <p>Please login</p>
</div>

<!-- <router-outlet></router-outlet> -->